<template>
<container class="">
    <div class="quiz">
        <h6 v-if="getLearnerLesson.completed" class="mb-4 font-bold text-lg">
            You have already answered this exercise
        </h6>
        <div class="description flex justify-between mb-4">
            <h6 class="mb-4 font-bold text-lg">{{ exercise.title }}</h6>
            <span class="tenant-main-color">{{ parseInt(exercise.score) }} marks</span>
        </div>
        <p v-if="exercises.length > 0 && exercises[0].story !== null" v-html="exercises[0].story"></p>
        <br />
        <div v-if="!getLearnerLesson.completed">
            <div class="question mb-8">
                <p class="float-right font-bold ">{{currentIndex + 1}}/{{exercise.questions.length}}</p>
                <div class="question-head mb-4 flex justify-between font-black">
<!--                    <h6>Question {{ currentIndex + 1 }}</h6>-->
                </div>
                <div class="mb-4">
                    <p v-html="exercise.questions[currentIndex].question">

                    </p>
                    <ltextarea style="width:100%!important" v-model="answers[currentIndex]" :disabled="showAnswers" placeholder="Enter Answer" />
                </div>
            </div>
            <div v-if="!getLearnerLesson.completed" class="w-full flex justify-center">
                <lms-button class="float-left mr-5" v-if="currentIndex !== 0" @click="showPrevious(currentIndex)">Previous Question</lms-button>
                <lms-button v-if="!showAnswers && exercise.questions.length === currentIndex + 1" @click.prevent="popConfirm">Submit</lms-button>
                <lms-button class="float-right ml-10" v-if=" exercise.questions.length !== currentIndex + 1" @click="showNext(currentIndex)">Next Question</lms-button>
            </div>
        </div>

        <div v-else>
            <div v-for="(question, i) in JSON.parse(submitted_answer)" :key="i" class="question mb-8">
                <div class="question-head mb-4 flex justify-between font-black">
                    <h6>Question {{ i + 1 }}</h6>
                </div>
                <div class="mb-4">
                    <p>
                        {{ question.question }}
                    </p>
                    <ltextarea v-model="question.answer" disable placeholder="Enter Answer" />
                </div>
            </div>
            <div v-if="!getLearnerLesson.completed" class="w-full flex justify-center">
                <lms-button v-if="!showAnswers" @click.stop="markExercise">Submit</lms-button>
            </div>
        </div>
    </div>
</container>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations
} from "vuex";
export default {
    props: ["exercise", "submitted_answer"],
    data() {
        return {
            answers: [],
            showAnswers: false,
            exercises: [],
            currentIndex: 0
        };
    },
    components: {
        container: () => import("@/components/general/container"),
        LmsButton: () => import("@/components/general/button"),
        ltextarea: () => import("@/components/general/textarea"),
    },
    computed: {
        ...mapGetters(["getUser", "getLearnerLesson"]),
    },
    methods: {
        popConfirm() {
            this.$confirm({
                message: `Hi ${this.getUser.first_name}. Are you sure you're ready to submit your ${this.exercise.title} Exercise? You would not be able to make any changes after. Proceed?`,
                button: {
                    no: "No",
                    yes: "Yes",
                },

                callback: (confirm) => {
                    if (confirm) {
                        this.markExercise();
                    }
                },
            });
        },
        ...mapActions(["learnerSubmitExercise","completeLesson"]),
         ...mapMutations(["updateLoader"]),
        async markExercise() {
            this.updateLoader(true)
            this.showAnswers = true;
            let answers = [];
            for (let i = 0; i < this.exercise.questions.length; i++) {
                let data = {
                    id: this.exercise.questions[i].id,
                    exercise_id: this.exercise.id,
                    question: this.exercise.questions[i].question,
                    score: 0,
                    answer: this.answers[i],
                };
                answers.push(data);
            }
            let res = await this.learnerSubmitExercise({
                id: this.$route.params.lesson_id,
                answers,
            });
            if (res == true || res.status == 200 || res.status == 201) {
                this.form = {};
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Exercise taken successfully",
                });
                 let res = await this.completeLesson({
                  id: this.$route.params.lesson_id
                });
                this.updateLoader(false)
                this.$emit('exercise-submitted', 'someValue')
               // if(res.status){
               //     this.updateLoader(false)
               //     location.reload()
               //
               // }
               this.updateLoader(false)
            } else {
                this.updateLoader(false)
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: res.data.errors ?
                        res.data.errors[0].title : "An error occured",
                });
            }
        },
        showNext(index) {
            this.currentIndex++

        },
        showPrevious(index) {
            this.currentIndex--;

        },
    },
    mounted() {
        this.exercises = this.exercise.questions;
        this.exercises = [...this.exercises].reverse()
    }
};
</script>

<style lang="scss" scoped>
.quiz {
    .navs {
        color: color(lms-tenant);
    }

    .description {
        h6 {
            color: color(lms-tenant);
        }
    }

    .question-head {
        color: color(lms-tenant);
    }
}
</style>
